import getRandomId from '@/v2/utils/random-id'
import { format } from 'date-fns'

export const generateEmptyProvider = () => ({
  id: getRandomId(),
  provider: '',
  type: '',
  specialty: '',
  taxonomy: '',
  taxId: '',
  npi: '',
  npiType: '',
  address1: '',
  address2: '',
  city: '',
  state: '',
  zipcode: '',
  kind: '',
})

export const generateEmptyProcedure = () => ({
  startDate: format(new Date(), 'yyyy-MM-dd'),
  id: getRandomId(),
  procedureCode: '',
  fee: null,
  quantity: 1,
})

export const genderOptions = [
  { label: 'Male', value: 'male' },
  { label: 'Female', value: 'female' },
]

export const normalizeGender = value => {
  if (!value || typeof value !== 'string') return ''
  const v = value.trim().toLowerCase()
  if (v === 'm' || v === 'male') return 'male'
  if (v === 'f' || v === 'female') return 'female'
  return ''
}

export const sequenceCodeOptions = [
  { label: 'Primary', value: 'primary' },
  { label: 'Secondary', value: 'secondary' },
  { label: 'Tertiary', value: 'tertiary' },
]

export const modalTitle = {
  edit: 'Edit Claim',
  view: 'View Claim',
  create: 'Create Claim',
}

export const ctaButtonTitle = {
  edit: 'Save',
  view: 'Close',
  create: 'Create',
}

export const modalHeihgt = {
  edit: 'auto',
  view: 'auto',
  create: 'auto',
}

export const imageTypeCode = [
  { label: 'B4 - Referral Form', value: 'B4' },
  { label: 'DA - Dental Models', value: 'DA' },
  { label: 'DG - Diagnostic Report', value: 'DG' },
  { label: 'EB - Explanation of Benefits', value: 'EB' },
  { label: 'OZ - Other Attachments', value: 'OZ' },
  { label: 'P6 - Periodontal Charts', value: 'P6' },
  { label: 'RB - X-Rays', value: 'RB' },
  { label: 'RR - Radiology Reports', value: 'RR' },
  { label: 'XP - Intra-Oral Photograph', value: 'XP' },
  { label: '03 - Narrative', value: '03' },
]

export const imageOrientations = [
  {
    label: 'Left',
    value: 'LEFT',
  },
  {
    label: 'Right',
    value: 'RIGHT',
  },
]

export const convertFileToBase64 = file => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  })
}
